import { supabase } from "@/integrations/supabase/client";

/**
 * Public lead capture.
 *
 * Visitors are allowed to CREATE quote requests / shop orders but (by design)
 * are NOT allowed to READ any submission rows. That means a plain
 * `.insert(...).select("id")` from the browser fails with a 401/42501, because
 * PostgREST needs a SELECT policy to return the inserted row.
 *
 * These helpers call SECURITY DEFINER database functions instead, which insert
 * the row and return ONLY the new row's id — no read access is exposed.
 */

export type QuoteRequestRow = {
  product_id?: string | null;
  product_name: string;
  customer_name: string;
  customer_email: string;
  customer_phone?: string | null;
  shipping_address?: string | null;
  size_option?: string | null;
  fabric_option?: string | null;
  color_option?: string | null;
  quantity?: number | null;
  notes?: string | null;
  source_page?: string | null;
  source_form?: string | null;
  referrer?: string | null;
};

export type ShopOrderRow = {
  product_id?: string | null;
  product_name: string;
  product_price?: number | null;
  customer_name: string;
  customer_email: string;
  customer_phone?: string | null;
  shipping_address?: string | null;
  quantity?: number | null;
  notes?: string | null;
  source_page?: string | null;
  source_form?: string | null;
  referrer?: string | null;
};

type Result = { id: string | null; error: { message: string } | null };

export async function insertQuoteRequest(row: QuoteRequestRow): Promise<Result> {
  const { data, error } = await supabase.rpc("create_quote_request", {
    payload: row as never,
  });
  if (error) {
    console.error("[lead-insert] create_quote_request failed", error.message);
    return { id: null, error };
  }
  return { id: (data as string | null) ?? null, error: null };
}

export async function insertShopOrder(row: ShopOrderRow): Promise<Result> {
  const { data, error } = await supabase.rpc("create_shop_order", {
    payload: row as never,
  });
  if (error) {
    console.error("[lead-insert] create_shop_order failed", error.message);
    return { id: null, error };
  }
  return { id: (data as string | null) ?? null, error: null };
}
